import { render, staticRenderFns } from "./Cart-Old.vue?vue&type=template&id=11d29a11"
import script from "./Cart-Old.vue?vue&type=script&lang=js"
export * from "./Cart-Old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports